import demandService from '@/service/demand';
import localforage from 'localforage';
import { observable, action, runInAction } from 'mobx';


// 获取人均福利分布

const moRole = observable({
  roleType: 'chart',
  roleActive: 'hot',
  roleActive1: 'hot',
  subRoleList: ['全部', '全部'],
  categoryList: <any>[],
  chartList1: <any>[],
  chartList2: <any>[],
});

// 切换各城市招聘需求量及变化表格图表

const changeRoleType = action(async (val: string) => {
  runInAction(() => {
    moRole.roleType = val;
  });
  const local: any = await localforage.getItem('demand') || {};
  local['roleType'] = val;
  localforage.setItem('demand', local)
});

const changeSubRoleList = action((val: any) => {
  runInAction(() => {
    moRole.subRoleList = val
  })
})

// 切换各城市招聘需求量及变化tab

const changeRoleActive = action(async (val: string) => {
  let num = "";
  moRole.categoryList.forEach((item: any, i: any) => {
    if (item.name === val) {
      if (i === moRole.categoryList.length - 1) {
        num = moRole.categoryList[0].name
      } else {
        num = moRole.categoryList[i + 1].name
      }
    }
  })
  runInAction(() => {
    moRole.roleActive = val;
    moRole.roleActive1 = num;
    moRole.subRoleList = ['全部', '全部'];
  });
  const parmes1 = {
    category_lv0: val,
    category_lv2: '',
  }
  const parmes2 = {
    category_lv0: num,
    category_lv2: '',
  }
  const [list1, list2] = await Promise.all([demandService.getChartList(parmes1), demandService.getChartList(parmes2)])
  runInAction(() => {
    moRole.chartList1 = list1;
    moRole.chartList2 = list2;
  });
  // const local: any = await localforage.getItem('demand') || {};
  // local['roleActive'] = val;
  // local['roleActive1'] = num;
  // local['subRoleList'] = ['全部', '全部'];
  // localforage.setItem('demand', local)
});

// 修改子职能

const changeSubRole = action(async (val: string, i: number) => {
  const list = [...moRole.subRoleList];
  list[i] = val;
  let list1: any = [];
  let list2: any = [];
  if (i === 0) {
    const parmes1 = {
      category_lv0: moRole.roleActive,
      category_lv2: list[0] === '全部' ? "" : list[0],
    }
    list1 = await demandService.getChartList(parmes1);
    runInAction(() => {
      moRole.chartList1 = list1;
    });
  }
  if (i === 1) {
    const parmes2 = {
      category_lv0: moRole.roleActive1,
      category_lv2: list[1] === '全部' ? "" : list[1],
    }
    list2 = await demandService.getChartList(parmes2);
    runInAction(() => {
      moRole.chartList2 = list2;
    });
  }
  runInAction(() => {
    moRole.subRoleList = list;
  });
  // const local: any = await localforage.getItem('demand') || {};
  // local['subRoleList'] = list;
  // local['chartList1'] = list1;
  // local['chartList2'] = list2;
  // localforage.setItem('demand', local)
});

// 获取职能列表

const getCategoryList = action(async () => {
  // const local: any = await localforage.getItem('demand') || {};
  const list = await demandService.getCategoryList();
  runInAction(() => {
    moRole.categoryList = list;
    moRole.roleActive = list[0].name;
    moRole.roleActive1 = list[1].name;
  });
});

// 获取图表数据
const getChartList = action(async () => {
  const parmes1 = {
    category_lv0: moRole.roleActive,
    category_lv2: moRole.subRoleList[0] === '全部' ? "" : moRole.subRoleList[0],
  }
  const parmes2 = {
    category_lv0: moRole.roleActive1,
    category_lv2: moRole.subRoleList[1] === '全部' ? "" : moRole.subRoleList[1],
  }
  const [list1, list2] = await Promise.all([demandService.getChartList(parmes1), demandService.getChartList(parmes2)])
  runInAction(() => {
    moRole.chartList1 = list1;
    moRole.chartList2 = list2;
  });
});

export default moRole;
export {
  changeRoleType, changeRoleActive, changeSubRole, getCategoryList, getChartList, changeSubRoleList
};
